import {DoppeDtoUserSettings} from "./doppe-dto-user-settings";
import {DoppeFreemiumPlan} from "../doppe-premium";

export interface DoppeDtoAppFeatures {
    showInviteToTryHoppTo?: boolean;
    showInviteToTryActionPages?: boolean;
    showInviteToTryPreRolls?: boolean;
    showInviteToTryLinksShortener?: boolean;
    multiplePagesMode?: boolean;
    whiteDoppeAppPageBackground?: boolean;
    stripeFeaturesEnabled?: boolean;
    enablePagesCaching?: boolean;
    freemiumPlan?: DoppeFreemiumPlan;
}

export const DoppeDtoAppFeaturesDefaultValues: Required<DoppeDtoAppFeatures> = {
    showInviteToTryHoppTo: false,
    showInviteToTryActionPages: false,
    showInviteToTryPreRolls: false,
    showInviteToTryLinksShortener: false,
    whiteDoppeAppPageBackground: false,
    multiplePagesMode: false,
    stripeFeaturesEnabled: false,
    enablePagesCaching: false,
    freemiumPlan: DoppeFreemiumPlan.None,
}

export function doppeDtoAppFeatureGetValue<K extends keyof DoppeDtoAppFeatures>(
    userSettings: DoppeDtoUserSettings | undefined,
    settingName: K
) {
    return (
        userSettings?.[settingName] ??
        DoppeDtoAppFeaturesDefaultValues[settingName]
    ) as Required<DoppeDtoAppFeatures>[K]
}